//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Basic from './Basic';
import Family from './Family';
import Resume from '../Resume';

export default {
  name: 'Profile',
  components: { Basic, Family, Resume },
};
